// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "ms-teams-auth-adapter" + "." + "6a7b2bb0" + ".css";
};